module.exports = __webpack_public_path__ + "static/logo-text-a1f35f00357d3afb056c189d9b65a072.svg";